import { createReducer } from '@reduxjs/toolkit'

import {
  setLoading,
  setParticipantSummary,
  setNotFound,
  setParticipantTags,
  setTags,
  setParticipantTagsError,
  setParticipantNotes,
  setParticipantActivities,
  setProjects,
  setNotesProjectId,
  setActivitiesProjectId,
  setNewNotesCount,
  setSignupFormAnswers,
  setParticipantSignupFormResponse,
  setSignupFormErrors,
  setSignupFormQuestions,
  setSignupFormQuestionsLoading,
} from 'containers/ParticipantProfile/Redux/Actions'

export const initialState = {
  participantSummary: {
    unsubscribed: false,
  },
  signupFormQuestions: {
    loading: false,
    questions: [],
  },
  participantNotes: {
    data: [],
    notesProjectId: '',
    newNotesCount: 0,
  },
  participantActivities: {
    data: [],
    activitiesProjectId: '',
  },
  participantTags: {
    hasError: false,
    errorMessage: '',
    value: [],
  },
  loading: false,
  notFound: false,
  tags: [],
  projects: [],
  signupFormAnswers: {
    answers: {},
    errors: [],
    blankQuestions: [],
  },
}

// linting ignored as yarn format is causing unwanted semicolons to appear.
// prettier-ignore
export const participantProfileReducer = createReducer(initialState, {
  [setLoading.type]: (state, action) => {
    state.loading = action.payload
  },

  [setParticipantTagsError.type]: (state, action) => {
    state.participantTags.hasError = action.payload
  },

  [setParticipantSummary.type]: (state, action) => {
    state.participantSummary = action.payload.participant
    state.loading = false
    state.notFound = false
  },

  [setParticipantNotes.type]: (state, action) => {
    state.participantNotes = {
      ...state.participantNotes,
      data: action.payload.participantNotes,
    }
    state.loading = false
    state.notFound = false
  },

  [setParticipantActivities.type]: (state, action) => {
    state.participantActivities = {
      ...state.participantActivities,
      data: action.payload.participantActivities,
    }
    state.loading = false
    state.notFound = false
  },

  [setNotFound.type]: (state, action) => {
    state.notFound = action.payload
    state.loading = false
  },

  [setParticipantTags.type]: (state, action) => {
    state.participantTags.value = action.payload.tags
  },

  [setTags.type]: (state, action) => {
    state.tags = action.payload.tags
  },

  [setProjects.type]: (state, action) => {
    state.projects = action.payload.projects
  },

  [setNotesProjectId.type]: (state, action) => {
    state.participantNotes = {
      ...state.participantNotes,
      notesProjectId: action.payload.projectId,
    }
  },
  [setActivitiesProjectId.type]: (state, action) => {
    state.participantActivities = {
      ...state.participantActivities,
      activitiesProjectId: action.payload.projectId,
    }
  },

  [setNewNotesCount.type]: (state, action) => {
    state.participantNotes = {
      ...state.participantNotes,
      newNotesCount: action.payload,
    }
  },

  [setParticipantSignupFormResponse.type]: (state, action) => {
    state.signupFormAnswers.answers = action.payload
  },

  [setSignupFormAnswers.type]: (state, action) => {
    state.signupFormAnswers = {
      ...state.signupFormAnswers,
      answers: {
        ...state.signupFormAnswers.answers,
        [action.payload.key]: action.payload.value,
      },
    }
  },

  [setSignupFormErrors.type]: (state, action) => {
    state.signupFormAnswers = {
      ...state.signupFormAnswers,
      errors: action.payload.value.errors,
    }
  },

  [setSignupFormQuestions.type]: (state, action) => {
    state.signupFormQuestions.questions = action.payload.questions
  },

  [setSignupFormQuestionsLoading.type]: (state, action) => {
    state.signupFormQuestions.loading = action.payload
  },
})

export default participantProfileReducer
